import { generatePath } from 'react-router';

import { extractPathParamsAndBackfillParams } from './extractPathParamsAndBackfillParams';
import { InternalRoute } from './types';

export const interpolateRoutePath = (
  route: InternalRoute,
  interpolationParams: Record<string, string | undefined>,
  shouldErrorOnMissingRequiredParams = true,
): string => {
  const sanitizedParams = extractPathParamsAndBackfillParams(
    route.path,
    interpolationParams,
    shouldErrorOnMissingRequiredParams,
  );

  return generatePath(route.path, sanitizedParams);
};
